export default __webpack_public_path__ + "static/media/withdraw-ecredit-step4-option2.f89b1fad.png";